import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
} from '@/components/ui/dialog';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';
import { useEffect, useState } from 'react';
import { ChartContent, type ViewMode } from './chart-content';

interface ChartExpandModalProps {
	isOpen: boolean;
	onOpenChange: (open: boolean) => void;
	viewMode: ViewMode;
}

export function ChartExpandModal({
	isOpen,
	onOpenChange,
	viewMode: initialViewMode,
}: ChartExpandModalProps) {
	// Internal state for view mode toggle
	const [viewMode, setViewMode] = useState<ViewMode>(initialViewMode);

	// Reset view mode when modal opens or initial view mode changes
	useEffect(() => {
		setViewMode(initialViewMode);
	}, [initialViewMode, isOpen]);

	// Dynamic title based on the view mode
	const modalTitle =
		viewMode === 'daily'
			? 'Daily Rate Recommendations - Expanded View'
			: 'Avg Daily Rate Recommendations - Expanded View';

	// Handle view mode toggle
	const handleViewModeChange = (checked: boolean) => {
		setViewMode(checked ? 'daily' : 'average');
	};

	return (
		<Dialog open={isOpen} onOpenChange={onOpenChange}>
			<DialogContent className='tw-max-w-[95vw] tw-max-h-[95vh] sm:tw-max-w-[90vw] sm:tw-max-h-[90vh] lg:tw-max-w-[85vw] lg:tw-max-h-[85vh] tw-w-full tw-h-full tw-p-3 sm:tw-p-6 tw-flex tw-flex-col tw-overflow-hidden'>
				<DialogHeader className='tw-flex-shrink-0'>
					<div className='tw-flex tw-flex-col tw-space-y-3 sm:tw-flex-row sm:tw-items-center sm:tw-space-y-0 sm:tw-space-x-4'>
						<div className='tw-flex tw-items-center tw-space-x-2'>
							<Label
								htmlFor='view-mode-toggle'
								className='tw-text-sm tw-font-medium'
							>
								Daily
							</Label>
							<Switch
								id='view-mode-toggle'
								checked={viewMode === 'daily'}
								onCheckedChange={handleViewModeChange}
							/>
						</div>
						<DialogTitle className='tw-text-lg sm:tw-text-xl tw-font-semibold tw-leading-tight'>
							{modalTitle}
						</DialogTitle>
					</div>
				</DialogHeader>
				<div className='tw-flex-1 tw-overflow-auto tw-mt-3 sm:tw-mt-4 tw-min-h-0'>
					<ChartContent
						viewMode={viewMode}
						className='tw-w-full tw-h-full tw-min-h-[250px] sm:tw-min-h-[300px] lg:tw-min-h-[400px]'
						height={undefined}
					/>
				</div>
			</DialogContent>
		</Dialog>
	);
}
